import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ExtintoresPage from "./pages/ExtintoresPage";
import SinalizacaoPage from "./pages/SinalizacaoPage";
import IluminacaoPage from "./pages/IluminacaoPage";
import GalvanizadosPage from "./pages/GalvanizadosPage";
import MangueirasPage from "./pages/MangueirasPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import FloatingWhatsApp from "./components/site/FloatingWhatsApp";
import { Toaster } from "./components/ui/sonner";
import SmoothScroll from "./components/SmoothScroll";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/produtos/extintores" element={<ExtintoresPage />} />
              <Route path="/produtos/sinalizacao" element={<SinalizacaoPage />} />
              <Route path="/produtos/iluminacao" element={<IluminacaoPage />} />
              <Route path="/produtos/galvanizados" element={<GalvanizadosPage />} />
              <Route path="/produtos/mangueiras" element={<MangueirasPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </SmoothScroll>
          <FloatingWhatsApp />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
